export const categoriesMock = [
  { microId: 1, macroId: 10, alberoCategorie: "Elettronica;TV e Audio" },
  { microId: 2, macroId: 10, alberoCategorie: "Elettronica;Smartphone" },
  { microId: 3, macroId: 20, alberoCategorie: "Casa;Elettrodomestici" },
];

function makeProduct({ index, vendorId, ordine }) {
  const base = 1000 + index;
  const imgSeed = base % 1000;
  const brands = ["Acme", "Contoso", "Globex", "Initech"];
  const brand = brands[index % brands.length];

  return {
    catalogListId: base + 1,
    productListId: base + 2,
    nome: `Prodotto demo nome lungo ${index + 1}`,
    codiceEan: String(1000000000000 + index).slice(0, 13),
    categoryListId: categoriesMock[index % categoriesMock.length].microId,
    disponibilita: index % 3 === 0 ? 0 : 120 - index * 2,
    prezzoDiRiferimento: 79.9 + index,
    prezzoVendita: 69.9 + index,
    speseDiSpedizione: 4.99,
    marca: brand,
    taxCode: "TAXCODE",
    peso: 1.2,
    sdiCode: "SDICODE",
    descrizione:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae arcu nec elit tempor feugiat. Integer interdum urna quis porta maximus.",
    linkImmagine: `https://picsum.photos/seed/prod-main-${imgSeed}/400/260`,
    linkImmagine1: `https://picsum.photos/seed/prod-alt1-${imgSeed}/400/260`,
    linkImmagine2: `https://picsum.photos/seed/prod-alt2-${imgSeed}/400/260`,
    linkOfferta: "https://www.example.com/offerta-demo",
    alberoCategorie: categoriesMock[index % categoriesMock.length].alberoCategorie,
    numClickGenerati: (index + 1) * 3,
    caratteristicheTecniche: "CPU quad-core, 8GB RAM, SSD 256GB.",
    vendorId,
    metodiPagamentoIds: [1, 2],
    certificato: index % 4 === 0 ? false : true,
    isDeleted: index % 7 === 0 ? 1 : 0,
    isDisattivato: index % 5 === 0 ? 1 : 0,
    stato: index % 3 === 0 ? 1 : 3,
    role: "vendor",
    ordine,
  };
}

export function buildProductsSearchMockResponse({
  limit,
  page,
  vendorId,
  ordine,
  ricerca,
  soloDisattivati,
  soloEliminati,
}) {
  const vId = Array.isArray(vendorId) ? vendorId[0] : vendorId;
  const safeLimit = typeof limit === "number" ? limit : 30;
  const safePage = typeof page === "number" ? page : 0;

  const allProducts = Array.from({ length: 55 }).map((_, i) =>
    makeProduct({ index: i, vendorId: vId, ordine })
  );

  const filtered = allProducts.filter((product) => {
    if (soloDisattivati && product.isDisattivato !== 1) {
      return false;
    }
    if (soloEliminati && product.isDeleted !== 1) {
      return false;
    }
    return true;
  });

  const totalCatalog = filtered.length;
  const start = safePage * safeLimit;
  const products = filtered.slice(start, start + safeLimit);

  return {
    products,
    maxNumPage: Math.ceil(totalCatalog / safeLimit),
    totalsResults: totalCatalog,
    statusCode: 202,
    numClickGenerati: products.reduce((acc, p) => acc + (p.numClickGenerati ?? 0), 0),
    ricerca,
  };
}

